<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="布产"
      :page="page"
      :get-data-func="apilist"
      show-checkbox
      show-query
      :query-params="params"
      @check-change="checkChange"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="订单号">
            <el-input v-model="params.a" placeholder="订单号" />
        </el-form-item>
        <el-form-item label="布产单号">
            <el-input v-model="params.b" placeholder="布产单号" />
        </el-form-item>
        <el-form-item label="客户名称">
            <el-input v-model="params.c" placeholder="客户名称" />
        </el-form-item>
        <el-form-item label="产品名称">
            <el-input v-model="params.d" placeholder="产品名称" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="订单号" prop="a" min-width="170" show-overflow-tooltip />
        <el-table-column label="布产单号" prop="b" min-width="170" show-overflow-tooltip />
        <el-table-column label="单据日期" prop="c" min-width="120" show-overflow-tooltip />
        <el-table-column label="客户名称" prop="d" min-width="120" />
        <el-table-column label="部门" prop="e" min-width="70" />
        <el-table-column label="业务员" prop="f" width="80" />
        <el-table-column label="存货编码" prop="g" width="90" />
        <el-table-column label="存货名称" prop="h" width="100" />
        <el-table-column label="适用bom" prop="i" width="100" />
        <el-table-column label="颜色" prop="j" width="100" />
        <el-table-column label="单位" prop="k" width="100" />
        <el-table-column label="数量" prop="l" width="100" />
      </template>
    </list>
  </div>
</template>
<script>


import listMixin from "@/mixins/list";
import list from "@/components/common/list";



export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
        params: {

        },
        list: [],
    };
  },

  methods: {
    checkChange(list){
        this.list = list;
    },
    apilist(){
        return new Promise((resolve, reject) => {
           
            resolve({
             Code: 0,
             Count: 3,
             Data: [
             {
                a: 1,
                b: 1,
                c: 1,
                d: 1,
                e: 1,
                f: 1,
                g: 1,
                h: 1,
                i: 1,
                j: 1,
                k: 1,
                l: 1,
             },
             {
                a: 21,
                b: 21,
                c: 21,
                d: 21,
                e: 21,
                f: 21,
                g: 21,
                h: 21,
                i: 21,
                j: 21,
                k: 21,
                l: 21,
             },
             {
                a: 31,
                b: 31,
                c: 31,
                d: 31,
                e: 31,
                f: 31,
                g: 31,
                h: 31,
                i: 31,
                j: 31,
                k: 31,
                l: 31,
             }
           ]
           })
       })
    }
  }
};
</script>
